<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body no-body-scroll" [hidden]="minimise">
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!showFormLoader) {
<div>
    <ul class="nav nav-pills" role="tablist">
      @for (tab of tabs; track $index) {
<li [class.active]="tab.id === activeTab">
        <a (click)="onTabChange(tab)" style="cursor: pointer;" class="btn-sm">{{ tab.name }}</a>
      </li>
}
    </ul>

    <div class="tab-content" style="overflow-y: auto; max-height: calc(90vh - 200px);">
      <div class="form-horizontal tab-content-padding" style="padding-top: 0 !important;">
        <form class="form-horizontal" novalidate>
          <div class="row" style="padding-bottom: 0 !important;">
            <table class="table table-bordered form-inline enityDetails custom-table">
              <tr>
                @for (kv of entityList | keyvalue; track kv.key) {
<td><span>{{ kv.key }}</span></td>
}
              </tr>
              <tr>
                @for (kv of entityList | keyvalue; track kv.key) {
<td><span>{{ kv.value }}</span></td>
}
              </tr>
            </table>
            @if (f8991FormData?.length) {
<table class="table table-bordered form-inline custom-table">
              <tr>
                <td>Name:
                  <div>
                    <input class="form-control input-md numText text_field_width" style="width: 100%;"
                           type="text" [ngModel]="rowData?.LE_NAME" name="leName" readonly>
                  </div>
                </td>
                <td>Employer identification number:
                  <div>
                    <input class="form-control input-md numText text_field_width" style="width: 100%;"
                           type="text" maxlength="10" [ngModel]="rowData?.EIN" name="ein" readonly>
                  </div>
                </td>
              </tr>
            </table>
}
            @if (f8991FormData?.length) {
<table class="table table-bordered form-inline InnerTblBG custom-table">
              @for (row of f8991FormData; track $index; let mainIndex = $index) {
<tr class="row">
                @if (row.ROW_TYPE === 'TH') {

                  @for (item of row.Line_data; track $index) {
<td style="font-weight: bold;"
                      [attr.align]="item.COL_CLASS" [attr.colspan]="item.COLSPAN"
                      [ngClass]="{'color-red': item.ATTRIB_VALUE < 0 }">
                    @if (item.DESCRIPTION === 'Unallocated Amount' && unAllocatedAmt !== 0) {
<p style="color:red;">{{ item.ATTRIB_VALUE | numberWithCommas }}</p>
}
                    @if (item.DESCRIPTION === 'Unallocated Amount' && unAllocatedAmt === 0) {
<p style="color:green;">{{ item.ATTRIB_VALUE | numberWithCommas }}</p>
}
                    @if (item.DESCRIPTION !== 'Unallocated Amount') {
<p>{{ item.ATTRIB_VALUE | numberWithCommas }}</p>
}
                  </td>
}
                
}
                @if (row.ROW_TYPE === 'PH') {
<td style="font-weight: bold;" class="row" colspan="10">
                  {{ row.Line_data?.[0]?.ATTRIB_VALUE }}
                </td>
}
                @if (row.ROW_TYPE === 'DT') {

                  @for (item of row.Line_data; track $index; let idx = $index) {
<td class="row" [attr.colspan]="item.COLSPAN">
                    @if (item.EDIT_TYPE === 'currency' && item.DATA_TYPE === 'number') {
<p>
                      <input [ngModel]="item.ATTRIB_VALUE" (ngModelChange)="item.ATTRIB_VALUE = $event; valuechanged(mainIndex, null, item.LINE_NO, idx)"
                             class="form-control input-md numText number-field" type="text"
                             (blur)="updateAmount(idx, item.LINE_NO)"
                             [disabled]="item.IS_EDITABLE_CELL === 'N'" name="dt_cur_{{mainIndex}}_{{idx}}">
                    </p>
}
                    @if (item.EDIT_TYPE === 'checkbox' && item.DATA_TYPE === 'string') {
<p>
                      @if (item.ATTRIB_DESCRIPTION === 'NA') {
<input type="checkbox"
                             [ngModel]="item.ATTRIB_VALUE === 'Y'" (ngModelChange)="item.ATTRIB_VALUE = $event ? 'Y' : 'N'; valuechanged(mainIndex, null, item.LINE_NO, idx)">
}
                      @if (item.ATTRIB_DESCRIPTION !== 'NA') {

                        <input type="checkbox" [ngModel]="item.ATTRIB_VALUE === 'Y'" (ngModelChange)="item.ATTRIB_VALUE = 'Y'; valuechanged(mainIndex, null, item.LINE_NO, idx)">
                        <label>&nbsp;{{ item.CHECKBOX_LABELS?.[0] }}</label><br>
                        <input type="checkbox" [ngModel]="item.ATTRIB_VALUE === 'N'" (ngModelChange)="item.ATTRIB_VALUE = 'N'; valuechanged(mainIndex, null, item.LINE_NO, idx)">
                        <label>&nbsp;{{ item.CHECKBOX_LABELS?.[1] }}</label>
                      
}
                    </p>
}
                    @if (item.EDIT_TYPE === 'label' && item.DATA_TYPE === 'string') {
<p>{{ item.ATTRIB_VALUE }}</p>
}
                  </td>
}
                
}
                @if (row.ROW_TYPE === 'RT') {

                  @for (item of row.Line_data; track $index; let idx = $index) {
<td class="row" [attr.colspan]="item.COLSPAN">
                    @if (item.EDIT_TYPE === 'radio' && item.DATA_TYPE === 'string') {
<p>
                      <input type="radio" [name]="'rt_' + mainIndex + '_' + idx" value="Yes" [ngModel]="item.ATTRIB_VALUE" (ngModelChange)="item.ATTRIB_VALUE = $event; valuechanged(mainIndex, null, item.LINE_NO, idx)"> Yes
                      <input type="radio" [name]="'rt_' + mainIndex + '_' + idx" value="No" [ngModel]="item.ATTRIB_VALUE" (ngModelChange)="item.ATTRIB_VALUE = $event; valuechanged(mainIndex, null, item.LINE_NO, idx)"> No
                    </p>
}
                    @if (item.EDIT_TYPE === 'label' && item.DATA_TYPE === 'string') {
<p>{{ item.ATTRIB_VALUE }}</p>
}
                  </td>
}
                
}
                @if (row.ROW_TYPE === 'LH') {
<td colspan="10">
                  <table class="table table-bordered form-inline InnerTblBG custom-table">
                    @for (lhRow of row.Line_data; track $index; let lhIdx = $index) {
<tr class="row">
                      @if (lhRow.ATTRIB_SHORT_CODE?.indexOf('HEADER') !== -1) {

                        @for (h of lhRow.Line_data; track $index) {
<th class="row">
                          <p>{{ h.ATTRIB_VALUE }}</p>
                        </th>
}
                      
}
                      @if (lhRow.ATTRIB_SHORT_CODE?.indexOf('HEADER') === -1) {

                        @for (cell of lhRow.Line_data; track $index; let cellIdx = $index) {
<td class="row">
                        @if (cell.EDIT_TYPE === 'label' && cell.DATA_TYPE === 'string') {
<p [attr.colspan]="cell.COLSPAN">{{ cell.ATTRIB_VALUE }}</p>
}
                        @if (cell.EDIT_TYPE === 'currency' && cell.DATA_TYPE === 'number') {
<p>
                          <input class="form-control input-md numText number-field" type="text"
                                 [ngModel]="cell.ATTRIB_VALUE" (ngModelChange)="cell.ATTRIB_VALUE = $event; valuechanged(mainIndex, null, cell.LINE_NO, cellIdx)"
                                 (blur)="updateAmount(cellIdx, cell.LINE_NO)"
                                 [disabled]="cell.IS_EDITABLE_CELL === 'N'">
                        </p>
}
                        @if (cell.EDIT_TYPE === 'text' && cell.DATA_TYPE === 'string') {
<p>
                          <input type="text" [ngModel]="cell.ATTRIB_VALUE" (ngModelChange)="cell.ATTRIB_VALUE = $event; valuechanged(mainIndex, null, cell.LINE_NO, cellIdx)"
                                 [disabled]="cell.IS_EDITABLE_CELL === 'N'">
                        </p>
}
                        @if (cell.EDIT_TYPE === 'select' && cell.DATA_TYPE === 'string') {
<p>
                          @if (cell.ATTRIB_SHORT_CODE?.indexOf('CONVENTION') !== -1) {
<select
                                  [ngModel]="cell.ATTRIB_VALUE" (ngModelChange)="cell.ATTRIB_VALUE = $event; valuechanged(mainIndex, null, cell.LINE_NO, cellIdx)"
                                  [disabled]="cell.IS_EDITABLE_CELL === 'N'">
                            @for (c of convensions; track $index) {
<option [value]="c">{{ c }}</option>
}
                          </select>
}
                          @if (cell.ATTRIB_SHORT_CODE?.indexOf('METHOD') !== -1) {
<select
                                  [ngModel]="cell.ATTRIB_VALUE" (ngModelChange)="cell.ATTRIB_VALUE = $event; valuechanged(mainIndex, null, cell.LINE_NO, cellIdx)"
                                  [disabled]="cell.IS_EDITABLE_CELL === 'N'">
                            @for (m of methods; track $index) {
<option [value]="m">{{ m }}</option>
}
                          </select>
}
                          @if (cell.ATTRIB_SHORT_CODE?.indexOf('CONVENTION') === -1 && cell.ATTRIB_SHORT_CODE?.indexOf('METHOD') === -1 && CountriesList?.values?.length) {
<select
                                  [ngModel]="cell.ATTRIB_VALUE" (ngModelChange)="cell.ATTRIB_VALUE = $event; valuechanged(mainIndex, null, cell.LINE_NO, cellIdx)"
                                  [disabled]="cell.IS_EDITABLE_CELL === 'N'">
                            @for (country of CountriesList.values; track $index) {
<option [value]="country.VALUE">{{ country.LABEL }}</option>
}
                          </select>
}
                        </p>
}
                        @if (cell.EDIT_TYPE === 'checkbox' && cell.DATA_TYPE === 'string') {
<p>
                          <input type="checkbox" [ngModel]="cell.ATTRIB_VALUE === 'Y'" (ngModelChange)="cell.ATTRIB_VALUE = $event ? 'Y' : 'N'; valuechanged(mainIndex, null, cell.LINE_NO, cellIdx)">
                        </p>
}
                        </td>
}
                      
}
                    </tr>
}
                  </table>
                </td>
}
                @if (row.ROW_TYPE === 'CH') {
<td colspan="10">
                  <table class="table table-bordered form-inline InnerTblBG custom-table">
                    @for (chItem of row.Line_data; track $index) {
<tr class="row">
                      @if (chItem.Line_Type === 'HEADER_ROW') {

                        @for (col of chItem.Line_data_occ; track $index) {
<th class="row">
                          @if (col.ATTRIB_DESCRIPTION !== 'Comments') {
<p>{{ col.ATTRIB_VALUE }}</p>
}
                        </th>
}
                      
}
                      @if (chItem.Line_Type === 'SUB_ROW') {
<td class="row">{{ chItem.Line_no }}</td>
}
                      @if (chItem.Line_Type === 'SUB_ROW') {
<td class="row" colspan="9">Add Details</td>
}
                      @if (chItem.Line_Type === 'DATA_ROW' && chItem.Is_Multi === 'Y') {
<td class="row"></td>
}
                      @if (chItem.Line_Type === 'DATA_ROW' && chItem.Is_Multi === 'Y') {

                        @for (col of chItem.Line_data_occ?.slice(1, chItem.Line_data_occ?.length) || []; track $index; let colIdx = $index) {
<td class="row">
                        @if (col.ATTRIB_DESCRIPTION !== 'Comments' && col.DATA_TYPE === 'number') {
<p [ngClass]="{'color-red': col.ATTRIB_VALUE < 0 }">
                          {{ col.ATTRIB_VALUE | numberWithCommas }}
                          @if (col.HAS_ERROR === 'Y') {
<span class="form-error-container">{{ col.ATTRIB_VALUE_ERROR }}</span>
}
                        </p>
}
                        @if (col.ATTRIB_DESCRIPTION !== 'Comments' && col.DATA_TYPE !== 'number') {
<p>
                          {{ col.ATTRIB_VALUE }}
                          @if (col.HAS_ERROR === 'Y') {
<span class="form-error-container">{{ col.ATTRIB_VALUE_ERROR }}</span>
}
                        </p>
}
                        </td>
}
                      
}
                      @if (chItem.Line_Type === 'DATA_COMMENTS' && chItem.Is_Multi === 'Y') {
<td class="row" colspan="2">
                        <h4 style="font-weight: bold;">{{ chItem.Line_data_occ?.[0]?.ATTRIB_DESCRIPTION }}:</h4>
                      </td>
}
                      @if (chItem.Line_Type === 'DATA_COMMENTS' && chItem.Is_Multi === 'Y') {
<td class="row" colspan="8">
                        {{ chItem.Line_data_occ?.[0]?.ATTRIB_VALUE }}
                      </td>
}
                      @if (chItem.Line_Type === 'NEW_EDIT_ROW' && chItem.Is_Multi === 'Y') {

                        @for (col of chItem.Line_data_occ?.slice(1) || []; track $index; let colIdx = $index) {
<td class="row">
                        @if (col.EDIT_TYPE === 'label' && col.DATA_TYPE === 'number') {
<p>{{ col.ATTRIB_VALUE }}</p>
}
                        @if (col.EDIT_TYPE === 'radio' && col.DATA_TYPE === 'string') {
<p>
                          <input type="radio" [name]="'ch_' + colIdx" value="Perm" [ngModel]="col.ATTRIB_VALUE" (ngModelChange)="col.ATTRIB_VALUE = $event; valuechanged(mainIndex, col.OCCURRENCE, col.LINE_NO, colIdx)"> Perm
                          <input type="radio" [name]="'ch_' + colIdx" value="Temp" [ngModel]="col.ATTRIB_VALUE" (ngModelChange)="col.ATTRIB_VALUE = $event; valuechanged(mainIndex, col.OCCURRENCE, col.LINE_NO, colIdx)"> Temp
                        </p>
}
                        @if (col.EDIT_TYPE === 'text' && col.DATA_TYPE === 'string') {
<p>
                          <textarea style="width: 100%" class="form-control input-sm" [ngModel]="col.ATTRIB_VALUE" (ngModelChange)="col.ATTRIB_VALUE = $event; valuechanged(mainIndex, col.OCCURRENCE, col.LINE_NO, colIdx)" placeholder="<-- Description -->"></textarea>
                          @if (col.HAS_ERROR === 'Y') {
<span class="form-error-container">{{ col.ATTRIB_VALUE_ERROR }}</span>
}
                        </p>
}
                        @if (col.EDIT_TYPE === 'currency' && col.DATA_TYPE === 'number') {
<p>
                          <input class="form-control input-md numText" type="text" [ngModel]="col.ATTRIB_VALUE" (ngModelChange)="col.ATTRIB_VALUE = $event; valuechanged(mainIndex, col.OCCURRENCE, col.LINE_NO, colIdx)"
                                 (blur)="updateAmount(mainIndex, col.LINE_NO)" [disabled]="col.IS_EDITABLE_CELL === 'N'">
                        </p>
}
                        @if (col.EDIT_TYPE === 'checkbox' && col.DATA_TYPE === 'string') {
<p>
                          <input type="checkbox" [ngModel]="col.ATTRIB_VALUE === 'Y'" (ngModelChange)="col.ATTRIB_VALUE = $event ? 'Y' : 'N'; valuechanged(mainIndex, col.OCCURRENCE, col.LINE_NO, colIdx)">
                        </p>
}
                        </td>
}
                      
}
                    </tr>
}
                  </table>
                </td>
}
              </tr>
}
            </table>
}
            @if (!f8991FormData?.length && !showFormLoader) {
<p class="text-muted">No data for this section.</p>
}
          </div>
        </form>
      </div>
    </div>
  </div>
}
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="crudLoading || isSaveClicked" (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save and Proceed
  </button>
  <button class="reset-button" type="button" (click)="reset()">Reset</button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
